import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouteLink } from 'react-router-dom'
import { useIntl } from 'react-intl'

import {
    Breadcrumb as ChakraBreadcrumb,
    BreadcrumbItem as ChakraBreadcrumbItem,
    BreadcrumbLink as ChakraBreadcrumbLink,
    useStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

const messages = {
    myAccount: {
        id: 'drawer_menu.button.my_account',
        defaultMessage: 'My Account'
    },

    orderHistory: {
        id: 'drawer_menu.button.order_history',
        defaultMessage: 'Order History'
    },

    orderNumber: {
        id: 'account_order_detail.label.order_number',
        defaultMessage: 'Order #{orderNo}'
    }
}

const AccountBreadCrumb = ({ params = {}, ...rest }) => {
    const styles = useStyleConfig('Breadcrumb')
    const intl = useIntl()

    const orderLabel = params.orderNo || params.orderId || ''
    const breadCrumbs = [
        {
            id: 'account',
            name: intl.formatMessage(messages.myAccount),
            path: '/account'
        },
        {
            id: 'order-history',
            name: intl.formatMessage(messages.orderHistory),
            path: '/account/orders'
        },
        ...(orderLabel
            ? [
                {
                    id: orderLabel,
                    name: intl.formatMessage(messages.orderNumber, {
                        orderNo: orderLabel
                    }),
                    path: `/account/orders/${params.orderId}`
                }
            ]
            : [])
    ]

    return (
        <ChakraBreadcrumb
            className="sf-breadcrumb"
            {...styles.container}
            separator="/"
            color="grey.800"
            marginTop="0"
            {...rest}
        >
            {breadCrumbs.map((breadcrumb, index) => {
                const isLastItem = index === breadCrumbs.length - 1

                return (
                    <ChakraBreadcrumbItem
                        key={breadcrumb.id}
                        data-testid="account-breadcrumb-item"
                    >
                        <ChakraBreadcrumbLink
                            data-testid="account-breadcrumb-link"
                            as={isLastItem ? 'span' : RouteLink}
                            to={isLastItem ? undefined : breadcrumb.path}
                            {...(!isLastItem && styles.link)}
                            color={isLastItem ? 'black' : 'grey.800'}
                            fontWeight="400"
                            aria-current={isLastItem ? 'page' : undefined}
                            sx={{ textTransform: 'capitalize' }}
                        >
                            {breadcrumb.name}
                        </ChakraBreadcrumbLink>
                    </ChakraBreadcrumbItem>
                )
            })}
        </ChakraBreadcrumb>
    )
}

AccountBreadCrumb.displayName = 'AccountBreadCrumb'

AccountBreadCrumb.propTypes = {
    params: PropTypes.shape({
        orderId: PropTypes.string,
        orderNo: PropTypes.string
    })
}

export default AccountBreadCrumb